module.exports = __webpack_public_path__ + "img/ca.3ee4784a.png";